import * as ProjectRepository from "repository/ProjectRepository";
import sortObjectsArray from "sort-objects-array";
import { Context } from 'context';

export const getProject = async (projectId, mapPack) => {


    const {id, ...metadata} = await ProjectRepository.getProject(projectId);

    let mapPacks = await ProjectRepository.getProjectMapPacks(projectId);
    mapPacks = sortObjectsArray(mapPacks, "mapCount");

    let mapPackToGet = null;
    let mapPackPriority = ["tuner", "full"];

    if (mapPack) {
        mapPackPriority.unshift(mapPack);
    }

    let mapPackExists = false;
    while (!mapPackExists) {
        if (mapPackPriority.length < 1) {
            window.location.href = `/${projectId}`;
        }
        mapPackToGet = mapPackPriority.shift()
        mapPackExists = mapPacks.some(mapPack => mapPack.name === mapPackToGet);
    }

    let folderStructure = await ProjectRepository.getProjectMapPackFolders(projectId, mapPackToGet);
    if(folderStructure.length < 1) new Error("No folders found");
    folderStructure = sortObjectsArray(folderStructure, "titleDescription");

    const calibrationData = await ProjectRepository.getProjectCalibrationData(projectId);

    return {id, mapPack: mapPackToGet, mapPacks, metadata, folderStructure, calibrationData}
};

export const getModifiedCalibrationData = async (projectId) => {
    return ProjectRepository.getModifiedProjectCalibrationData(projectId);
};